/*
  C LP Entrepreneur — "A day with Apollo" scroll-linked timeline (section c-lp-ent-day).
  Ports the design team's prototype ("timeline (scroll-linked, Ana's request)" + "12 header + rows"):
  - A progress bar fills the spine (scaleY from the top). The fill line sits at 56% of the viewport height.
  - The active stop is the last one whose dot the fill has reached (with a 40px lead): its dot grows
    (scale 1.55) and fills peach, past dots fill, the active time pill fills peach and scales 1.04.
  - The bottom cap turns peach when the fill reaches the end.
  - Each card slides in from its side (x +-48px, .8s) and its pill fades in (.5s, .2s delay) the first
    time 40% of the row is visible. Rows already on screen at load are left alone.
  - Reduced motion: no slides, the fill jumps to the active stop, CSS transitions are off.
  Scroll listeners sit on window AND document.body because the store preview scrolls body.
  Handles shopify:section:load / unload for the theme editor.
*/
(function () {
  'use strict';
  if (window.cLpEntDayTimeline) return;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';
  var instances = [];

  function clamp(v, a, b) {
    return Math.max(a, Math.min(b, v));
  }

  function setupSlides(root, rows) {
    if (reduce || !('IntersectionObserver' in window) || !root.animate) return [];
    var observers = [];
    var wide = window.matchMedia('(min-width: 990px)').matches;
    rows.forEach(function (row, i) {
      var card = row.querySelector('[data-day-card]');
      var pill = row.querySelector('[data-day-pill]');
      if (!card || !pill) return;
      var r = row.getBoundingClientRect();
      if (!(r.top >= window.innerHeight * 0.92 || r.bottom <= 0)) return; // already on screen
      var side = i % 2 === 0 ? -48 : 48;
      var from = wide ? 'translateX(' + side + 'px)' : 'translateY(28px)';
      card.style.opacity = '0';
      card.style.transform = from;
      pill.style.opacity = '0';
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            io.disconnect();
            var c = card.animate(
              { opacity: [0, 1], transform: [from, 'translate(0, 0)'] },
              { duration: 800, easing: EASE, fill: 'both' }
            );
            var p = pill.animate({ opacity: [0, 1] }, { duration: 500, delay: 200, easing: EASE, fill: 'both' });
            var done = function () {
              card.style.opacity = '';
              card.style.transform = '';
              pill.style.opacity = '';
              try { c.cancel(); p.cancel(); } catch (err) { /* noop */ }
            };
            c.finished.then(done, done);
          });
        },
        { threshold: 0.4 }
      );
      io.observe(row);
      observers.push(io);
    });
    return observers;
  }

  function init(root) {
    if (root.__cLpEntDay) return;
    var tl = root.querySelector('[data-day-timeline]');
    var prog = root.querySelector('[data-day-progress]');
    var capb = root.querySelector('[data-day-cap-bottom]');
    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-day-row]'));
    if (!tl || !prog || !rows.length) return;

    var ticking = false;
    var last = -1;
    var inst = { root: root, observers: [] };

    function update() {
      ticking = false;
      var r = tl.getBoundingClientRect();
      var progTop = prog.offsetTop;
      var H = prog.offsetHeight;
      if (!H) return;
      var line = window.innerHeight * 0.56;
      var y = clamp(line - r.top - progTop, 0, H);
      var centres = rows.map(function (row) {
        var dot = row.querySelector('[data-day-dot]');
        var d = (dot || row).getBoundingClientRect();
        return d.top + d.height / 2 - r.top - progTop;
      });
      var act = 0;
      for (var i = 0; i < centres.length; i++) {
        if (y >= centres[i] - 40) act = i;
      }
      if (reduce) y = clamp(centres[act], 0, H);
      prog.style.transform = 'scaleY(' + Math.max(12 / H, y / H) + ')';
      if (act !== last) {
        rows.forEach(function (row, i) {
          row.classList.toggle('is-active', i === act);
          row.classList.toggle('is-past', i < act);
        });
        last = act;
      }
      if (capb) capb.classList.toggle('is-on', y >= H - 28);
    }
    function req() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }

    inst.req = req;
    window.addEventListener('scroll', req, { passive: true });
    document.body.addEventListener('scroll', req, { passive: true });
    window.addEventListener('resize', req);
    inst.destroy = function () {
      window.removeEventListener('scroll', req);
      document.body.removeEventListener('scroll', req);
      window.removeEventListener('resize', req);
      inst.observers.forEach(function (o) { o.disconnect(); });
    };

    inst.observers = setupSlides(root, rows);
    root.__cLpEntDay = inst;
    instances.push(inst);
    update();
  }

  function scan(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-c-lp-ent-day]'), init);
  }

  window.cLpEntDayTimeline = { scan: scan };
  scan();
  document.addEventListener('DOMContentLoaded', function () { scan(); });
  window.addEventListener('load', function () {
    instances.forEach(function (i) { i.req(); });
  });
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    instances = instances.filter(function (inst) {
      if (e.target.contains(inst.root)) {
        inst.destroy();
        return false;
      }
      return true;
    });
  });
})();
